import { compose } from 'recompose';
import { connect } from 'react-redux';

const mapStateToProps = () => ({
  providerContextHistory: true,
});

export const enhance = compose(
  connect(
    mapStateToProps,
    null,
  ),
);



// WEBPACK FOOTER //
// ./src/components/Healthboard/ProviderAppointmentList/AppointmentProviderHistory/enhance.js